export let life = {
  mounted () {
    this.$nextTick(() => {
      this.methods('setValueStyle')
    })
  }
}
export let event = {
}

export let watch = {}
